import { createSelector, createSlice, isAnyOf } from '@reduxjs/toolkit';
import type { AuthenticationSliceState } from '@bo-types/authentication';
import type { RootState } from '@bo-store';
import { authenticationApi } from '@bo-services/authenticationApi';
import { pluck } from 'ramda';

const initialState: AuthenticationSliceState = {
  isAuthenticated: false,
  user: undefined
};

const authenticationSlice = createSlice({
  name: 'authenticationSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authenticationApi.endpoints.getAdminCurrent.matchFulfilled,
        (_state, action) => ({
          isAuthenticated: true,
          user: action.payload?.data
        })
      )
      .addMatcher(
        isAnyOf(
          authenticationApi.endpoints.getAdminCurrent.matchRejected,
          authenticationApi.endpoints.logout.matchFulfilled
        ),
        () => initialState
      );
  }
});

export default authenticationSlice.reducer;

export const selectIsAuthenticated = (state: RootState) =>
  state.authenticationSlice.isAuthenticated;

export const selectLoggedInUserId = (state: RootState) =>
  state.authenticationSlice.user?.id;

export const selectUser = (state: RootState) => state.authenticationSlice.user;

export const selectUserRoles = createSelector(
  [selectUser],
  (user) => user?.attributes.roles || []
);

export const selectUserRoleNames = createSelector([selectUserRoles], (roles) =>
  pluck('name', roles)
);

export const selectMemberTransactionMaxes = (state: RootState) =>
  state.authenticationSlice.user?.attributes?.transaction_maxes || [];
